import React, { useState } from 'react';
import  IntroView from "./introView";
import {useLocation } from "react-router-dom";
import IntroMobileView from './introMobileView';
import MediaQuery from 'react-responsive';


const Intro:React.FC = () => {

    const [firstSearch, setFirstSearch] = useState('');
    
    
   
     const location = useLocation();
     const admin = location.state?.status;

    

     const level = admin !== undefined ? admin : "normal";


    const getSearch = (e: React.FormEvent<HTMLFormElement>) => {

        e.preventDefault();
        // setFirstSearch(e.currentTarget.value);

    }
   

    
 


    return (
  
        <div className='container'>
            {
                    level === ""  ? <div/> : 
            <div className='col'>
                
             
            <MediaQuery minWidth={1224}>
            <IntroView getSearch={getSearch} firstSearch={firstSearch} setFirstSearch={setFirstSearch} level={level}/>
            </MediaQuery>
            <MediaQuery maxWidth={1224}>
            <IntroMobileView getSearch={getSearch} firstSearch={firstSearch} setFirstSearch={setFirstSearch} level={level}/>
            </MediaQuery>
              
            </div>
             }
        </div>
        
    )

}


export default Intro;

function getTokenExpirationTime(accessToken: string) {
    throw new Error('Function not implemented.');
}
